<template>
  <main-layout>
    <div class="container">

      <!--nav class="navbar navbar-default" role="navigation">
        <div class="container-fluid">
          <div class="navbar-header">
            <div class="col-xs-2 header-img">
              <p><img src="http://wx.qlogo.cn/mmopen/7zVkCbG3KV0noJgWcib1eGVvXMBf7zuSsHduTMAOr7Q7cX5EibxLGwSTUVqqFywRCYEb1vbAoAEnceq7mSNUJqNzA3OAPzdMvX/0" class="img-responsive img-circle" alt="Responsive image"></p>
            </div>
            <div class="col-xs-4 header-text">
              <p class="text-left bg-warning" id="head-username">{{name}}</p>
              <p class="text-left text-warning bg-info" id="head-coin">{{coins}} 钢蹦</p>
            </div>
            <div class="col-xs-4"></div>
            <div class="col-xs-2 header-coin-img">
              <img src="http://alpha-go.tech/wiki/lib/exe/fetch.php?cache=&media=alphago:%E5%9B%BE%E8%A1%A8.png" class="img-responsive img-circle" alt="Responsive image">
            </div>
          </div>
        </div>
      </nav-->

      <!--div class="header">
        <div class="bs-docs-grid">
          <div class="row show-grid " id="head-title">
            <div class="col-xs-2 imagecss" id="head-img">
                <p><img src="http://wx.qlogo.cn/mmopen/7zVkCbG3KV0noJgWcib1eGVvXMBf7zuSsHduTMAOr7Q7cX5EibxLGwSTUVqqFywRCYEb1vbAoAEnceq7mSNUJqNzA3OAPzdMvX/0" class="img-responsive img-circle" alt="Responsive image"></p>
            </div>
            <div class="col-xs-4">
              <p class="text-left bg-warning" id="head-username">Crowxjy</p>
              <p class="text-left text-warning bg-info" id="head-coin">100 钢蹦</p>
            </div>
            <div class="col-xs-4"></div>
            <div class="col-xs-2">
                <img src="http://alpha-go.tech/wiki/lib/exe/fetch.php?cache=&media=alphago:%E5%9B%BE%E8%A1%A8.png" class="img-responsive img-circle" alt="Responsive image">
            </div>
          </div>
        </div>
      </div-->
      <div class="form-group has-feedback">
        <!--p>{{ community }}</p-->
        <input type="text" v-model="community" placeholder="请输入小区名（查询一次仅需1钢蹦）" @keyup.enter="submit">
        <!--input ref="input" v-model="community" v-bind:value="community" v-on:input="updateValue()"-->
        <span class="glyphicon glyphicon-remove-sign form-control-feedback"></span>
      </div>
      <hr/>

      <div class="row marketing">
        <div class="col-lg-6 text-center" >
          <h4>{{ subtitleMsg }}</h4>
            <!--div class="list-item" v-for="item in lists">
                <span>{{ item.text }}</span>
            </div-->
            <div class="list-item" v-for="item in lists" v-bind:key="item">
                <span>
                <!--router-link to="/detail" v-on:click="updateCm( item )">{{ item }}</router-link-->
                <router-link :to="{ path: '/detail', query: { cm: item }}">
                {{ item }}
                </router-link>
                <!--a href="/detail" v-on:click="updateCm( item )">{{ item }}</a-->
                <!--router-link :to="{name:'price'}">{{ item }}</router-link-->
                </span>
            </div>
            <!--div class="list-item">
                <span>上地西里小区</span>
                <span>上地西里小区</span>
                <span>上地南街</span>
                <p>蒙面歌王背锅</p>
                <p>不冒泡儿不</p>
                <p>V型许下的各个</p>
                <p>3如公屏那平</p>
                <p>本品牌管家婆</p>
                <p>别人而</p>
                <p>绝不能配不能碰</p>
                <p>帮帮我吧让我</p>
            </div-->
        </div>

      </div>

      <div class="footer text-center">
      </div>

    </div> <!-- /container -->

  </main-layout>
</template>

<script>
  import MainLayout from '../layouts/Main.vue'
  import wx from 'weixin-js-sdk'
  console.log("wx:%o", wx)
  import auth from '../auth'
  console.log("auth:%o", auth)

  export default {
    data () {
        return {
            titleMsg: '',
            subtitleMsg:'你可能感兴趣的小区',
            lists: ["上地国际创业园", "上地南路6号院", "上地东里","上地西里"],
            gridData: [],
            coins: 100,
            name: "Crowxjy",

            apiUrl: 'http://localhost/test/api/',
            reqHouseAreaUrl: 'https://alphago.chemucao.cn/real/index.php/community/deal?openid=ocwMjv_FhbsJTkhUNhAU7koY64Ps&token=alphago_admin_debug&community=',
            reqWxJSSignUrl: 'https://alphago.chemucao.cn/real/index.php/jsapi/sign?openid=ocwMjv_FhbsJTkhUNhAU7koY64Ps&token=alphago_admin_debug&url=',
            reqWxPaySignUrl: 'https://alphago.chemucao.cn/real/index.php/wxpay/launch?openid=ocwMjv_FhbsJTkhUNhAU7koY64Ps&token=alphago_admin_debug&money=101',

            wx_appId: "",
            wx_timestamp: "",
            wx_nonceStr: "",
            wx_signature: "",

            wxp_nonceStr: "",
            wxp_package: "",
            wxp_paySign: "",
            wxp_signType: "",
            wxp_timeStamp: "",


            testUrl: 'http://jsonplaceholder.typicode.com/posts',
            testData: {
              "code": 10,
              "msg": "not found",
              "data": {
                "guess": [
                  {
                    "name": "上地国际创业园"
                  },
                  {
                    "name": "上地南路6号院"
                  },
                  {
                    "name": "上地东里"
                  },
                  {
                    "name": "上地西里"
                  }
                ]
              }
            },

            token: 'alphago_admin_debug',
            openid: 'ocwMjv_FhbsJTkhUNhAU7koY64Ps',
            community: ''
        }
    },
    mounted() {
      console.info("mounted");
      //this.getBookLists();
      this.reqHouseArea(this.community);
    },
    created() {
        console.info("created currentRoute:%o", this.$root.currentRoute);
        this.reqWxJSSign();
        // this.reqWxPaySign();
    },
    methods: {
      submit: function(){
        console.debug("submit community:%s", this.community);
        this.reqHouseArea(this.community);
        auth.setCm(this.community);
      },
      updateCm: function(cm){
        console.debug("update cm:%s", cm)
        auth.setCm(cm);
      },
      // 不是直接更新值，而是使用此方法来对输入值进行格式化和位数限制
      updateValue: function (community) {
        console.debug("updateValue:%s", this.community);
        // this.addBookLists(this.community);
      },
      getBookLists: function() {
        console.debug("getBookLists");
        this.$http.get(this.apiUrl)
        .then((response) => {
          console.info("PASS! response:%o", response);
          console.log("status%s", response.status);
          console.log("statusText:%s", response.statusText);
          console.log("Expires: %s", response.headers.get('Expires'));
          console.log("body: %o", response.body.results);
          //this.$set('lists', response.body.results);
        }, (response) => {
          // error callback
          console.error("FAIL!!! response:%o", response);
        });
      },

      regWxJsApi: function(){
        console.debug("regWxJsApi");
        //console.debug("wx_appId:%s, wx_timestamp:%d, wx_nonceStr:%s, wx_signature:%s", this.wx_appId, this.wx_timestamp, this.wx_nonceStr, this.wx_signature);
        wx.config({
          debug: true,
          appId: this.wx_appId,
          timestamp: this.wx_timestamp,
          nonceStr: this.wx_nonceStr,
          signature: this.wx_signature,
          jsApiList: [
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone'
          ],
          success: function (res) {
            console.info("config successful!" + res);
          },
          error: function(json){
            console.error("config failed:" + json);
          }
        });
      },
      regWxPay: function(){
        console.debug("regWxPay");
        // console.debug("wxp_nonceStr:%s, wxp_package:%s, wxp_paySign:%s, wxp_signType:%s, wxp_timeStamp:%s", this.wxp_nonceStr, this.wxp_package, this.wxp_paySign, this.wxp_signType, this.wxp_timeStamp);
        wx.chooseWXPay({
          debug: true,
          timestamp: this.wxp_timeStamp,
          nonceStr: this.wxp_nonceStr,
          package: this.wxp_package,
          signType: this.wxp_signType,
          paySign: this.wxp_paySign,
          success: function (res) {
            console.info("pay successful!"+res);
          },
          error: function(json){
            console.error("pay failed:"+json);
          }
        });
      },
      reqWxJSSign: function(){
        var local_url = location.href.split('#')[0];
        // console.info("local_url:%s", local_url);
        var url = this.reqWxJSSignUrl + local_url;
        // console.debug("reqWxJSSign url:%s", url);
        this.$http.post(url, {foo:"bar"}).then((response) => {
          // console.info("PASS! response:%o", response);
          // console.log("status%s", response.status);
          // console.log("statusText:%s", response.statusText);
          // console.log("Expires: %s", response.headers.get('Expires'));
          // console.log("body: %o", response.body);
          var dl = response.body.data;
          this.wx_appId = dl.appId;
          this.wx_timestamp = dl.timestamp;
          this.wx_nonceStr = dl.nonceStr;
          this.wx_signature = dl.signature;
          // console.info("wx_appId:%s, wx_timestamp:%d, wx_nonceStr:%s, wx_signature:%s", this.wx_appId, this.wx_timestamp, this.wx_nonceStr, this.wx_signature);
          this.regWxJsApi();
        }, (response) => {
          // error callback
          console.error("FAIL!!! response:%o", response);
        });
      },
      reqWxPaySign: function(){
        var url = this.reqWxPaySignUrl;
        // console.debug("reqWxPaySign url:%s", url);
        this.$http.post(url, {foo:"bar"}).then((response) => {
          // console.info("PASS! response:%o", response);
          // console.log("status%s", response.status);
          // console.log("statusText:%s", response.statusText);
          // console.log("Expires: %s", response.headers.get('Expires'));
          // console.log("body: %o", response.body);
          var dl = response.body.data;
          this.wxp_nonceStr = dl.nonceStr,
          this.wxp_package = dl.package,
          this.wxp_paySign = dl.paySign,
          this.wxp_signType = dl.signType,
          this.wxp_timeStamp = dl.timeStamp,
          // console.info("wxp_nonceStr:%s, wxp_package:%s, wxp_paySign:%s, wxp_signType:%s, wxp_timeStamp:%s", this.wxp_nonceStr, this.wxp_package, this.wxp_paySign, this.wxp_signType, this.wxp_timeStamp);
          this.regWxPay();
        }, (response) => {
          // error callback
          console.error("FAIL!!! response:%o", response);
        });
      },
      reqHouseArea: function(community){
        console.info("community:%s", community);
        var url = this.reqHouseAreaUrl + community;
        console.debug("reqHouseArea url:%s", url);
        // this.$http.post(this.testUrl, this.testData).then((response) => {
        this.$http.post(url, {foo:"bar"}).then((response) => {
          // console.info("PASS! response:%o", response);
          // console.log("status%s", response.status);
          // console.log("statusText:%s", response.statusText);
          // console.log("Expires: %s", response.headers.get('Expires'));
          // console.log("body: %o", response.body);
          // console.log("data: %o", response.body.data.guess);
          var datalist = response.body.data.guess;
          // console.log("type:%o, datalist:%o", typeof(datalist), datalist);
          var od = [];
          // console.log("outputdata:%o", od);
          for(var p in datalist){
            // console.log(p + ":" + datalist[p]["name"]);
            od.push(datalist[p]["name"]);
          }
          //this.$set('lists', {})
          this.lists = od;
          // console.log("outputdata:%o", od);
          // this.$set(this.$data, 'list', od);
          //this.$set('gridData', response.body);
        }, (response) => {
          // error callback
          console.error("FAIL!!! response:%o", response);
        });
      }
    },
    components: {
      MainLayout
    }
  }
</script>

<style scoped>
  .list-item {
    margin-right: 10px;
  }
  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }
  .list-enter, .list-leave-active {
    opacity: 0;
    transform: translateY(30px);
  }

  .header-img img{margin:10px 10px 5px 0px;width:36px; height:36px;}
  .page-header {
    padding-bottom: 9px;
    margin: 40px 0 20px;
    border-bottom: 1px solid #eee;
  }
  #head-title {padding: 0px;padding-top: 14px;padding-bottom: 20px;vertical-align: middle;}
  #head-row {}
  [class*="col-"] {
    /*background-color: #eee;
    background-color: rgba(86,61,124,.15);
    border: 1px solid #ddd;
    border: 1px solid rgba(86,61,124,.2);
    min-height: 48px;*/
    /*vertical-align: middle;*/
    /*outline:#00ff00 dotted thick;*/
    /*vertical-align: middle;
    padding-top: 10px;*/
  }
  #head-username {font-size: 16px;padding-top: 0px; padding-bottom: 2px; margin:0px;}
  #head-coin {font-size: 14px;padding-top: 0px; padding-bottom: 0px;}
  .header-coin-img img{margin:12px 2px 12px 4px;width:24px; height:24px;}


</style>



// WEBPACK FOOTER //
// Home.vue?a3e9b648